module.exports = __webpack_public_path__ + "static/img/preview-02.18ad0091.webp";